module.exports = __webpack_public_path__ + "440811d2f1147a9c788637e37ee3ba1b.png";